module.exports = __webpack_public_path__ + "img/error.e13d9a41.svg";